module.exports = __webpack_public_path__ + "static/img/h5-home.f74e2a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/h5-home.png
// module id = 5Rn+
// module chunks = 1